export enum EAmplitudeEvents {
  LANDING_VIEW = 'landingHero_view',
  LANDING_BEGIN = 'landingBegin_action',
  LANDING_LOGIN = 'landingLogin_action',
  PLANS_ACTION = 'landingPlans_action',
  PLANS_VIEW = 'landingPlans_view',
  QUOTE_VIEW = 'landingQuote_view',
  QUOTE_ACTION = 'landingQuote_action'
}
